import React, { useEffect, useState ,useRef} from "react";
import { ReactComponent as PlayIcon } from "../../../../assets/Icons/play1.svg";
import { ReactComponent as AddToPlaylistIcon } from "../../../../assets/Icons/addtoplaylist.svg";
import { ReactComponent as MoreDetailsIcon } from "../../../../assets/Icons/moredetails.svg";
import { ReactComponent as RemoveFromPlaylistIcon } from "../../../../assets/Icons/removefromplaylist.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { imageUrlCheck, getDeviceType } from "../../../../utils/utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { useWindowWidth } from "@react-hook/window-size";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import Translate from "../../../../Components/Multilanguage/Translate";
import BannerUtil from "../../Components/util.jsx";
import { EffectFade, Thumbs, Autoplay } from "swiper";

const GaiaBanner = ({ data }) => {
  const [activeThumb, setActiveThumb] = useState();
  // const [isInWatchlist, setIsInWatchlist] = useState();
  const [watchlistStatus, setWatchlistStatus] = useState({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();
  const navigate = useNavigate();
  const deviceType = getDeviceType();

  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const myList = useSelector((state) => state?.myList?.myList) || [];
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const banner = projectInfo?.projectConfig?.config?.WEBSITE_BANNER;
  const isRTL = useSelector((state) => state?.rtl?.isRTL);

  const { 
    fetchWatchlist,
    updateWatchlist,
    addToWatchlist,
    removeFromWatchlist,
    truncateDescription,
    playClickHandler
  } = BannerUtil();
  
  const descriptionRef = useRef(null);   
  // const windowSize = useWindowWidth();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isNewVibe = projectInfo?.projectConfig?.pubid === 50146 && windowWidth > 768;

useEffect(() => {
  if (data?.shows?.length > 0) {
    const initialStatus = {};
    data.shows.forEach((item) => {
      initialStatus[item.show_id] = item.watchlist_flag;
    });
    setWatchlistStatus(initialStatus);
  }
}, [data]);

  const getMaxDescriptionLength = () => {
    if (windowWidth < 481) return 100;
    if (windowWidth < 981) return 150;
    if (windowWidth < 1201) return 175;
    return 150;
  };

  const handleSeeMore = (item) => {
    playClickHandler(item, { isSeeMore: true });
  };

  return (
    <div className={`${banner === "BANNER_4" ? 'gaiaFeatured2' : 'gaiaFeatured'} ${isRTL ? "rtl" : ""} ${projectInfo?.projectConfig?.pubid === 50134 ? "fwfg" : ""}`}>
      <Swiper
        onSwiper={setActiveThumb}
        slidesPerView={1}
        watchSlidesProgress
        effect={"fade"}
        spaceBetween={0}
        className="mySwiper"
        modules={[EffectFade, Thumbs, Autoplay]}
        allowTouchMove={false}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
      // allowSlideNext={false}
      // allowSlidePrev={false}
      >
        {data?.shows?.map((item, index) => (
          <SwiperSlide key={index}>
      <div className="bgImageContainer">
        {imageUrlCheck(item?.banner) ? (
          <img src={deviceType === "mobile" ? item?.banner_portrait : item?.banner} alt="BgImage" />
        ) : (
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}${deviceType === "mobile" ? item?.banner_portrait : item?.banner}`}
            alt="BgImage"
          />
        )}
      </div>

      <div className="contents">
        {item?.categories?.[0]?.category_name ? (
        <div className={`categoryName ${template === 'TEMPLATE_10' ? "gaia" : ""}`}>{item.categories[0].category_name} <Translate textKey={'chosen_for_you'} /></div>
        ) : null}
        <div className={`showCast ${!item?.show_cast ? 'hidden' : ''} ${template === 'TEMPLATE_10' ? "gaia" : ""}`}>{item?.show_cast}</div>
              <h1 className={`${isNewVibe ? "title newvibe" : "title"}`}>
                { (item?.image_title && imageUrlCheck(`${item.image_title}`)) ? (
                    <img src={`${item.image_title}`} alt={item.image_title || item.show_name} className="titleImage" />
                  ) : (
                    item?.show_name
                )}
              </h1>
              <div className={`details ${!(item?.director && item?.year) ? 'hidden' : ''}`}>
                <span className="director">{item?.director}</span>
                <span className="year">{item?.year}</span>
              </div>
              {isNewVibe ? (
                <>
              <p ref={descriptionRef} className="description newvibe">
                {truncateDescription(
                  item?.synopsis,
                  getMaxDescriptionLength()
                  )}
                  </p>
                  {item?.synopsis?.length > getMaxDescriptionLength() && (
                    <span
                      className="see-more newvibe"
                      onClick={() => handleSeeMore(item)}
                    >
                      <Translate textKey={"see_more"} />
                    </span>
                  )}
                </>
              ) : (
                <>
                  <p ref={descriptionRef} className="description">
                    {truncateDescription(
                      item?.synopsis, 
                      getMaxDescriptionLength()
                      )}
                    {item?.synopsis && item?.synopsis?.length > getMaxDescriptionLength() && (
                      <span
                        className="see-more"
                        onClick={() => 
                          
                          handleSeeMore(item)}
                    >
                      <Translate textKey={"see_more"} />
                    </span>
                  )}
              </p>
                </>
              )}
              <div className={`rating ${!(item?.duration_text && item?.rating) ? 'hidden' : ''}`}>
                <span
                  className={`duration ${item?.year ? "showDot" : ""} ${/^[A-Za-z0-9\s]+$/.test(item?.duration_text) ? "ltr" : ""}`}
                >
                  {item.duration_text}
                </span>
                <span className="certificate">{item?.rating}</span>
              </div>
              <div className={`${isNewVibe ? "buttonContainer newvibe" : "buttonContainer"}`}>
                {/* {(item?.show_id || item?.event_id && ( */}
                  <button className="watchNow" onClick={() => playClickHandler(item)}>
                    <PlayIcon />
                    <span><Translate textKey={'watch_now'} /></span>
                  </button>
                {/* )} */}
                {(item?.type === "SHOW" || item?.type === "BANNER") && (watchlistStatus[item.show_id] === 0 ? (
                  <button
                    className="addToPlaylist"
                    onClick={() => updateWatchlist(item?.show_id, 1, setWatchlistStatus)}
                  >
                    <AddToPlaylistIcon />
                    <Translate textKey={"add_to_mylist"} />
                  </button>
                ) : (
                  <button
                    className="addToPlaylist"
                    onClick={() => updateWatchlist(item?.show_id, 0, setWatchlistStatus)}
                  >
                    <RemoveFromPlaylistIcon />
                    <Translate textKey={'remove_from_mylist'} />
                  </button>
                ))}
            {item?.video_vanity_url && (<button className="moredetails" onClick={()=> playClickHandler(item, { showMoreInfo: true })}>
              <MoreDetailsIcon />
              <Translate textKey={'more_details'} />
            </button>)}
              </div>
            </div>
            </SwiperSlide>
        ))}
      </Swiper>
          </div>  
  );
};

export default GaiaBanner;